module.exports = __webpack_public_path__ + "images/aristo/bg_fallback.png";